/* eslint-disable */
export default {
  mute: 'Silenciar',
  unmute: 'Activar sonido',
  hangup: 'Colgar',
  reject: 'Rechazar',
  hold: 'Retener',
  onHold: 'En espera',
  transfer: 'Transferir',
  more: 'Más',
  stopRecord: 'Dejar de grabar',
  record: 'Grabar',
  showKeypad: 'Teclado',
  hideKeypad: 'Ocultar teclado',
  unHold: 'Salir de espera',
  forward: 'Transferir',
  ignore: 'Ignorar',
  voicemail: 'Enviar al buzón de voz',
  custom: 'Personalizar',
  answerAndEnd: 'Resp. y finalizar',
  answerAndHold: 'Resp. y poner en espera',
  answer: 'Responder',
  completeTransfer: 'Completar transferencia',
  reply: 'Responder',
  add: 'Agregar',
  mergeCall: 'Combinar con la llamada activa',
  endCallForEveryone: 'Finalizar llamada para todos',
  leaveCall: 'Salir de la llamada',
  leaveOrEndCall: '¿Desea salir o finalizar la llamada?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
